export const PATIENT_MESH_DPA_MARKDOWN = `# PATIENTMESH KİŞİSEL VERİLERİN İŞLENMESİ VE AKTARILMASINA İLİŞKİN TAAHHÜTNAME / VERİ İŞLEME SÖZLEŞMESİ (DPA)
### Medaxxa Medikal Sanayi Ticaret A.Ş.
**Son Güncelleme:** 4 Eylül 2026

---

### 1. TARAFLAR, AMAÇ VE SÖZLEŞMESEL KONUM
İşbu Kişisel Verilerin İşlenmesi ve Aktarılmasına İlişkin Taahhütname / Veri İşleme Sözleşmesi (DPA-Data Processing Agreement veya Kişisel Veri İşleme Sözleşmesi); PatientMesh hizmetini kullanan hekim, sağlık profesyoneli, klinik, hastane, sağlık kuruluşu veya diğer kurumsal müşteri (“Veri Sorumlusu/Müşteri”) ile Medaxxa Medikal Sanayi Ticaret A.Ş. (“Medaxxa” veya “Veri İşleyen”) arasında, PatientMesh üzerinden Veri Sorumlusu adına gerçekleştirilen kişisel veri işleme faaliyetlerini düzenlemek amacıyla akdedilmiştir.

* **Medaxxa Bilgileri:** Medaxxa Medikal Sanayi Ticaret A.Ş.; Vergi No: 6141862024; Kazlıçeşme Mah. 245. Sok. No:5 Zeytinburnu / İstanbul / Türkiye; E-posta: info@medaxxa.com.

Bu DPA, PatientMesh Kullanıcı Sözleşmesi, hizmet/abonelik sözleşmesi, teklif veya diğer ana sözleşmenin (“Ana Sözleşme”) ayrılmaz parçasıdır. Kişisel verilerin işlenmesi bakımından Ana Sözleşme ile bu DPA arasında çelişki bulunması halinde, emredici mevzuat saklı kalmak kaydıyla bu DPA hükümleri öncelikle uygulanır.

---

### 2. TANIMLAR
* **KVKK/Kanun:** 6698 sayılı Kişisel Verilerin Korunması Kanunu.
* **Veri Sorumlusu:** Kişisel verilerin işleme amaç ve vasıtalarını belirleyen ve veri kayıt sisteminin kurulmasından/yönetilmesinden sorumlu gerçek veya tüzel kişi.
* **Veri İşleyen:** Veri Sorumlusunun verdiği yetkiye dayanarak onun adına kişisel veri işleyen gerçek veya tüzel kişi.
* **İlgili Kişi:** Kişisel verisi işlenen gerçek kişi.
* **Özel Nitelikli Kişisel Veri:** KVKK m. 6 kapsamında özel korumaya tabi kişisel veriler; PatientMesh bakımından özellikle sağlık verileri.
* **Alt Veri İşleyen:** Medaxxa’nın Veri Sorumlusu adına yürüttüğü veri işleme faaliyetlerinin belirli bir kısmı için hizmet aldığı veri işleyen.
* **Kişisel Veri İhlali:** İşlenen kişisel verilerin kanuni olmayan yollarla başkaları tarafından elde edilmesi, yetkisiz açıklanması, kaybı, değiştirilmesi, yok edilmesi veya güvenlik/gizlilik/bütünlük/erişilebilirliğinin ihlal edilmesi sonucunu doğuran güvenlik olayı.
* **Talimat:** Veri Sorumlusunun Medaxxa’ya kişisel verilerin işlenmesine ilişkin verdiği yazılı, elektronik veya Ana Sözleşme/DPA’dan açıkça anlaşılabilen hukuka uygun talimat.
* **PatientMesh:** Medaxxa tarafından sunulan; hasta/klinik dosya yönetimi, planlı takip, PROM/ePROM, otomatik skorlama, klinik istatistik/araştırma ve uygun modüllerde makine öğrenmesi/öngörü fonksiyonlarını içeren web ve/veya mobil platform.

---

### 3. TARAFLARIN KVKK KAPSAMINDAKİ ROLLERİ
* **3.1.** Veri Sorumlusu/Müşteri, PatientMesh’e aktardığı veya PatientMesh üzerinden işlediği hastalar, danışanlar, araştırma katılımcıları, çalışanlar ve diğer ilgili kişilere ait veriler bakımından işleme amaç ve vasıtalarını belirlediği ölçüde Veri Sorumlusudur.
* **3.2.** Medaxxa, söz konusu verileri Veri Sorumlusunun talimatı üzerine PatientMesh hizmetinin sağlanması, barındırılması, güvenliği, teknik desteği, yedeklenmesi, bakım/güncellemesi ve sözleşmeyle kararlaştırılan fonksiyonların çalıştırılması için işlediği ölçüde Veri İşleyendir.
* **3.3.** Medaxxa’nın kullanıcı hesabı, kendi sözleşme/faturalama kayıtları, kendi bilgi güvenliği yükümlülükleri, kendi hukuki talepleri veya mevzuattan kaynaklanan bağımsız yükümlülükleri için amaç ve vasıtaları kendisinin belirlediği kişisel veri işleme faaliyetleri bu DPA’daki veri işleyen rolünün dışında olup, bu faaliyetler bakımından Medaxxa ayrıca veri sorumlusu olabilir.
* **3.4.** Medaxxa’nın Veri Sorumlusu adına işlediği hasta/klinik verilerine teknik olarak erişebilmesi, bu verileri kendi bağımsız amaçları için kullanma yetkisi vermez.
* **3.5.** Portalın kullanılması PatientMesh ile hasta arasında hekim-hasta ilişkisi, sağlık hizmeti sözleşmesi, tedavi taahhüdü, sonuç garantisi veya sürekli izleme yükümlülüğü oluşturmaz. PatientMesh, Hekimin almış olduğu hastaya ait özel verilere erişim sağlayamaz. Anonim bilgileri ve hekimin aldığı veri büyüklüğünü/ebatını görebilir, içeriğini göremez. Bu nedenle veri ihlalinde hasta doğrudan Hekime karşı hak talebinde bulunabilecektir. PatientMesh'in (Medaxxa Medikal) yalnızca teknik olarak siber saldırı olması ve veri ihlali anlamında bir açık vermesi halinde sorumluluğu doğacaktır.

---

### 4. İŞLEMENİN KONUSU, NİTELİĞİ, AMACI VE SÜRESİ
İşlemenin konusu; Veri Sorumlusunun PatientMesh’i kullanması sırasında PatientMesh’e aktardığı, kaydettiği, oluşturduğu veya sistem aracılığıyla işlediği kişisel verilerin, PatientMesh hizmetlerinin teknik olarak sağlanması amacıyla Medaxxa tarafından işlenmesidir.

İşleme faaliyetleri, hizmetin niteliğine göre; toplama/kaydetme, barındırma, düzenleme, yapılandırma, erişim sağlama, görüntüleme, sorgulama, yedekleme, geri yükleme, teknik aktarım, form/skor/rapor üretimi, teknik destek, güvenlik/loglama, veri dışa aktarma ve Veri Sorumlusunun talimatına bağlı silme/yok etme işlemlerini içerebilir.

İşleme süresi, kural olarak Ana Sözleşmenin yürürlük süresi ve sözleşme sonrasında veri iadesi/silme için gerekli makul geçiş süresiyle sınırlıdır. Kanuni saklama yükümlülüğü bulunan haller saklıdır.

---

### 5. İLGİLİ KİŞİ GRUPLARI VE VERİ KATEGORİLERİ
DPA kapsamında işlenebilecek ilgili kişi grupları ve veri kategorileri şunlardır:
* **İlgili Kişi Grupları:** Hastalar, danışanlar, araştırma katılımcıları, hasta yakınları/kanuni temsilciler, sağlık profesyonelleri, kurum çalışanları ve yetkilendirilmiş kullanıcılar.
* **Kimlik Verileri:** Ad-soyad, hasta/kullanıcı numarası ve hizmet için gerekli diğer tanımlayıcılar.
* **İletişim Verileri:** Telefon, e-posta ve gerekli olduğu ölçüde adres/iletişim bilgileri.
* **Sağlık ve Klinik Veriler:** Anamnez, tanı, tıbbi öykü, muayene/takip, tedavi, klinik ölçümler, laboratuvar veya görüntüleme ile ilişkili kayıtlar, PROM/ePROM yanıtları, ölçekler, skorlar, raporlar ve klinik değerlendirmeler.
* **İşlem Güvenliği ve Teknik Veriler:** IP, oturum, kullanıcı kimliği, erişim/log, cihaz, hata ve güvenlik kayıtları.
* **Araştırma Verileri:** Veri Sorumlusu tarafından yetkilendirilmiş araştırma sürecine dahil edilen klinik veya demografik veri alanları.
* **Diğer Veriler:** Veri Sorumlusunun PatientMesh’in yapılandırılabilir alanlarına hukuka uygun olarak girdiği ve hizmetin ifasıyla bağlantılı diğer kişisel veriler.

Veri Sorumlusu, hizmet için gerekli olmayan, ölçüsüz veya PatientMesh’in amacı dışında kalan kişisel verileri sisteme girmemeyi ve veri minimizasyonu ilkesine uygun hareket etmeyi taahhüt eder.

---

### 6. VERİ SORUMLUSUNUN YÜKÜMLÜLÜKLERİ
Veri Sorumlusu aşağıdaki yükümlülükleri yerine getirmekle sorumludur:
* Her bir kişisel veri işleme faaliyeti için KVKK m. 5 ve özel nitelikli kişisel veriler bakımından KVKK m. 6 kapsamında geçerli ve uygun bir işleme şartının bulunmasını sağlamak.
* İlgili kişilere KVKK m. 10 ve ilgili ikincil düzenlemeler uyarınca gerekli aydınlatmayı yapmak; açık rıza gereken hallerde rızayı aydınlatmadan ayrı ve hukuka uygun şekilde almak.
* PatientMesh’e yalnızca hukuka uygun olarak elde edilmiş ve işlenmesine yetkili olduğu kişisel verileri aktarmak.
* Sağlık verileri bakımından uygulanabilir sağlık mevzuatı, mesleki sır ve gizlilik yükümlülükleri, etik kurul/araştırma izinleri ve diğer sektörel gereklilikleri yerine getirmek.
* Kullanıcı rolleri ve erişim yetkilerini ihtiyaca göre belirlemek; görev değişikliği/ayrılma halinde yetkileri gecikmeksizin kaldırmak.
* Hesap, parola, MFA ve erişim araçlarını üçüncü kişilerle paylaşmamak; kendi kullanıcılarının hesap paylaşımını önlemek.
* İlgili kişi taleplerini kendisi değerlendirmek ve Medaxxa’dan yalnızca teknik destek istemek.
* Veri saklama ve imha sürelerini belirlemek ve Medaxxa’ya gerekli silme/iade talimatlarını vermek.
* PatientMesh üzerinden üretilen skor, rapor veya analitik çıktıları yetkili sağlık profesyonelinin bağımsız klinik değerlendirmesi yerine kullanmamak.

---

### 7. MEDAXXA’NIN VERİ İŞLEYEN OLARAK YÜKÜMLÜLÜKLERİ
Medaxxa:
* Kişisel verileri yalnızca Veri Sorumlusunun belgelenmiş ve hukuka uygun talimatları ile Ana Sözleşme/DPA kapsamında işler.
* Talimatın KVKK veya mevzuata açıkça aykırı olduğunu değerlendirmesi halinde Veri Sorumlusunu bilgilendirir; aykırı talimatı yerine getirmeyi askıya alabilir.
* Personelinin verilere yalnızca görevleri için gerekli ölçüde erişmesini sağlar ve gizlilik yükümlülüğüne tabi tutar.
* Kişisel verileri kendi pazarlama, bağımsız profil oluşturma veya ticari amaçları için kullanmaz.
* Veri Sorumlusunun yazılı onayı ve gerekli hukuki dayanak olmaksızın verileri bağımsız yapay zekâ modeli eğitimi veya veri seti satışı amacıyla kullanmaz.
* KVKK m. 12 çerçevesinde uygun teknik ve idari tedbirleri uygular.
* İlgili kişi talepleri, veri ihlalleri ve imha süreçlerinde Veri Sorumlusuna makul destek sağlar.

---

### 8. ÖZEL NİTELİKLİ KİŞİSEL VERİLER VE SAĞLIK VERİLERİ
PatientMesh kapsamında işlenen sağlık verileri KVKK m. 6 uyarınca özel nitelikli veridir. Veri Sorumlusu hukuki dayanağın sağlanmasından, aydınlatma ve rıza yükümlülüklerinden sorumludur. Medaxxa bu verilere erişimi rol bazlı sınırlandırır; erişim kayıtları, şifreleme ve ek güvenlik tedbirlerini riskle orantılı uygular.

---

### 9. TEKNİK VE İDARİ GÜVENLİK TEDBİRLERİ
Medaxxa, asgari tedbir çerçevesi EK-2’de gösterilen teknik ve idari tedbirleri uygular. Bu tedbirler mutlak güvenlik garantisi anlamına gelmez. Veri Sorumlusu da kendi uç cihazları, yerel ağları ve kullanıcı yetkileri bakımından güvenlik önlemlerini almakla yükümlüdür.

---

### 10. GİZLİLİK VE PERSONEL ERİŞİMİ
Medaxxa çalışanlarının yetkisiz erişimi, veri kopyalaması veya dışarı aktarması yasaktır. Gizlilik yükümlülüğü iş ilişkisi veya sözleşme sona erdikten sonra da süresiz devam eder.

---

### 11. ALT VERİ İŞLEYENLER
Veri Sorumlusu, bulut barındırma, yedekleme, siber güvenlik, SMS/iletişim ve teknik destek alanlarında alt veri işleyen kullanılabileceğini kabul eder. Medaxxa, alt veri işleyenlerle veri koruma yükümlülükleriyle uyumlu sözleşmeler tesis eder. Fiilî alt veri işleyen listesi EK-3’te güncel tutulur.

---

### 12. YURT DIŞINA VERİ AKTARIMI
Medaxxa, kişisel verileri yurt dışına ancak KVKK m. 9 ve ilgili yönetmelik kapsamındaki aktarım şartlarından birinin bulunması halinde aktarır. Kurul standart sözleşmeleri kullanılması gereken durumlarda ilgili tip sözleşme ayrıca akdedilir.

---

### 13. İLGİLİ KİŞİ BAŞVURULARI
İlgili kişi başvurularının ana muhatabı Veri Sorumlusudur. Medaxxa’ya doğrudan ulaşan talepler Veri Sorumlusuna iletilir ve talimat olmaksızın esas hakkında işlem yapılmaz.

---

### 14. KİŞİSEL VERİ İHLALİ VE GÜVENLİK OLAYI
Medaxxa, doğrulanmış bir veri ihlali tespit ettiğinde gereksiz gecikme olmaksızın Veri Sorumlusunu bilgilendirir. Kurul ve ilgili kişilere resmi bildirim yükümlülüğü Veri Sorumlusuna aittir; Medaxxa teknik bilgiyi makul ölçüde sağlar.

---

### 15. DENETİM, BİLGİ VE UYUM DESTEĞİ
Medaxxa, makul ölçüde gerekli bilgi ve uyum belgelerini Veri Sorumlusuna sağlayabilir. Bağımsız veya yerinde denetim taleplerinin kapsamı, zamanı ve maliyeti taraflarca önceden kararlaştırılır.

---

### 16. VERİ İHRACI, İADE, SİLME VE SÖZLEŞME SONU
Sözleşme bittiğinde Veri Sorumlusu tanınan süre içinde verilerini dışa aktarır. Süre sonunda kanuni saklama yükümlülükleri saklı kalmak üzere veriler silinir, yok edilir veya iade edilir. Yedek sistemlerdeki veriler rutin teknik döngü içinde erişime kapalı tasfiye edilir.

---

### 17. BİLİMSEL ARAŞTIRMA, ANONİMLEŞTİRME VE YAPAY ZEKÂ
PatientMesh’in araştırma modülleri bulunması, Veri Sorumlusuna her türlü hasta verisini sınırsız işleme hakkı vermez; gerekli etik kurul/kurum izinleri Veri Sorumlusuna aittir. Medaxxa, kişisel sağlık verilerini açık talimat olmadan bağımsız yapay zekâ eğitimi için kullanamaz. Gerçekten anonim hale getirilmiş veriler KVKK kapsamı dışında değerlendirilir.

---

### 18. VERİ DOĞRULUĞU VE KLİNİK SORUMLULUK
Medaxxa sağlık hizmeti sunucusu değildir; klinik kayıtların tıbbi doğruluğunu denetleme yükümlülüğü yoktur. Üretilen skor veya analitik çıktılar klinik karar destek niteliğindedir; nihai karar hekime aittir.

---

### 19. SORUMLULUK VE TAZMİNAT
Taraflar kendi kusur ve sorumluluk alanları ölçüsünde sorumludur. Veri Sorumlusunun hukuka aykırı veri işlemesinden veya yetkisiz erişiminden doğan zararlar kendi sorumluluğundadır. Medaxxa yalnızca veri işleyen yükümlülüklerini kusuruyla ihlal etmesinden doğan doğrudan zararlardan sorumludur.

---

### 20. YETKİLİ MAKAMLARDAN GELEN TALEPLER
Medaxxa, mahkeme veya yetkili idari makam taleplerinde yasal çerçevede hareket eder ve hukuken mümkünse Veri Sorumlusunu bilgilendirir.

---

### 21. SÖZLEŞMENİN SÜRESİ VE FESİH
Bu DPA, Medaxxa Veri Sorumlusu adına veri işlediği sürece yürürlükte kalır. Esaslı ihlallerde fesih hakları geçerlidir.

---

### 22. DEĞİŞİKLİKLER VE MEVZUATA UYUM
Mevzuat veya altyapı değişiklikleri nedeniyle DPA güncellenebilir; esaslı değişiklikler Veri Sorumlusuna duyurulur.

---

### 23. UYGULANACAK HUKUK VE UYUŞMAZLIK
Bu DPA Türk hukukuna tabidir. Yetkili mahkemeler Ana Sözleşmedeki esaslara göre belirlenir.

---

### 24. YÜRÜRLÜK VE KABUL
Bu DPA; taraflarca imzalanması, elektronik ortamda kabul edilmesi veya Ana Sözleşmede bu DPA’ya atıf yapılarak PatientMesh hizmetinin aktive edilmesiyle yürürlüğe girer.

---

### EK-1: VERİ İŞLEME TALİMATI VE KAPSAMI

| Başlık | Açıklama |
| :--- | :--- |
| **İşlemenin Konusu** | PatientMesh SaaS/platform hizmetinin Veri Sorumlusuna sunulması. |
| **İşlemenin Süresi** | Ana Sözleşme süresi + yasal saklama/silme geçiş süresi. |
| **İşlemenin Niteliği** | Kaydetme, barındırma, yedekleme, skorlama, güvenlik ve silme. |
| **İşlemenin Amacı** | Platform fonksiyonlarının güvenli teknik olarak sunulması. |
| **İlgili Kişi Grupları** | Hasta, danışan, araştırmacı, hekim, kurum personeli. |
| **Veri Kategorileri** | Kimlik, iletişim, sağlık/klinik, PROM/skor, log ve teknik veriler. |
| **Özel Nitelikli Veriler** | Özellikle sağlık ve klinik verileri. |

---

### EK-2: ASGARİ TEKNİK VE İDARİ TEDBİR ÇERÇEVESİ
* Rol tabanlı yetkilendirme ve en az yetki prensibi,
* Güçlü kimlik doğrulama mekanizmaları,
* Güvenli iletişim protokolleri ve riskle orantılı veri şifreleme,
* Erişim, işlem ve güvenlik loglarının tutulması,
* Düzenli yedekleme, felaket kurtarma ve iş sürekliliği süreçleri,
* Zafiyet ve yama yönetimi,
* Personel gizlilik taahhütleri ve güvenlik farkındalığı,
* Özel nitelikli veriler için ek erişim kontrolleri.

---

### EK-3: ALT VERİ İŞLEYENLER VE YURT DIŞI AKTARIM ENVANTERİ

| Alt Veri İşleyen | Hizmet | İşlenen Veri | İşleme/Hosting Ülkesi | Aktarım Mekanizması | Güvenlik Tedbiri |
| :--- | :--- | :--- | :--- | :--- | :--- |
| {{SUBPROCESSOR_NAME}} | {{SERVICE_TYPE}} | {{PROCESSED_DATA}} | {{HOSTING_COUNTRY}} | {{TRANSFER_MECHANISM}} | {{SECURITY_MEASURE}} |

---

### EK-4: VERİ İADE VE SİLME PROSEDÜRÜ
1. Sözleşme bitiminde Veri Sorumlusu tanınan geçiş süresinde verilerini dışa aktarır.
2. Veri Sorumlusunun yazılı/dijital talimatı üzerine aktif kayıtlar silinir veya iade edilir.
3. Yedek sistemlerdeki veriler rutin döngüde tasfiye edilir.
4. Yasal saklama zorunluluğu olan veriler erişimi sınırlandırılarak tutulur.
5. Teknik olarak mümkünse silme işlemine ilişkin makul bir teyit sağlanır.

---

### TARAFLAR VE ELEKTRONİK KABUL BİLGİSİ

| VERİ SORUMLUSU / MÜŞTERİ | VERİ İŞLEYEN |
| :--- | :--- |
| **Unvan/Ad Soyad:** {{DATA_CONTROLLER_TITLE_NAME}} | **Şirket:** Medaxxa Medikal Sanayi Ticaret A.Ş. |
| **Yetkili:** {{AUTHORIZED_PERSON}} | **Yetkili:** Medaxxa Yetkilisi |
| **Tarih:** {{ACCEPTANCE_DATE}} | **Tarih:** {{ACCEPTANCE_DATE}} |
| **Onay Durumu:** Elektronik Olarak Onaylandı | **Onay Durumu:** Sistem Tarafından Teyit Edildi |
`;
